<div><slot></slot></div>

<style>
  div {
    color: red;
  }
</style>
